import { gsap } from "gsap";

import { lenis } from "./scroll";

export default class LightboxHandler {
	team() {
		const triggers = gsap.utils.toArray('[data-lightbox="trigger"]');
		const items = gsap.utils.toArray('[data-lightbox="item"]');
		const containers = gsap.utils.toArray('[data-lightbox="container"]');
		const lightboxes = gsap.utils.toArray('[data-lightbox="lightbox"]');
		let currentIndex = 0; 
		
		const showContainer = (index) => {
			if (!lightboxes) return;
			currentIndex = (index + containers.length) % containers.length;
			containers.forEach(container => container.classList.add('hidden'));
			containers[currentIndex].classList.remove('hidden');
			lightboxes[0].classList.remove('hidden');
		};
		
		if (lightboxes.length > 1) {
			const firstLightbox = lightboxes[0];
			lightboxes.slice(1).forEach(lightbox => {
				const extraContainers = lightbox.querySelectorAll('[data-lightbox="container"]');
				extraContainers.forEach(container => firstLightbox.firstElementChild.appendChild(container));
				lightbox.remove();
			});
		}
		triggers.forEach((trigger) => {
			trigger.addEventListener('click', () => {
				const item = trigger.closest('[data-lightbox="item"]');
				const itemIndex = items.indexOf(item);
		
				if (itemIndex !== -1) {
					currentIndex = itemIndex;
					showContainer(currentIndex);
					lenis.stop();
				}
			});
		});
		gsap.utils.toArray('[data-lightbox="close"]').forEach((closeBtn) => {
			closeBtn.addEventListener('click', () => {
				lightboxes[0].classList.add('hidden');
				containers.forEach(container => container.classList.add('hidden'));
				lenis.start();
			});
		});
		gsap.utils.toArray('[data-lightbox="previous"]').forEach((prevBtn) => {
			prevBtn.addEventListener('click', () => {
				showContainer(currentIndex - 1);
			});
		});
		gsap.utils.toArray('[data-lightbox="next"]').forEach((nextBtn) => {
			nextBtn.addEventListener('click', () => {
				showContainer(currentIndex + 1);
			});
		});
	}
}